// extracted by mini-css-extract-plugin
module.exports = {"menuContent":"styles_menuContent__3Eg7U","typeFilter":"styles_typeFilter__2LhB5"};